<ds-button
  [attr.button-type]='"button"'
  [attr.reset-pair]='""'
  [attr.button-ui-variant]='"tertiary"'
  [attr.button-size]='"medium"'
  [attr.button-label]='"UploadButtonStr" | translate'
  [attr.button-icon]='"icon-upload"'
  [attr.is-disabled]="false"
  [attr.button-aria-label]='"UploadButtonStr" | translate'
  [attr.animation-play]="false"
  [attr.is-enable-activated]="false"
  [attr.has-aria-popup]='""'
  (onClickEvent)='goToUploadDocument()'
  [attr.button-aria-controls]='""'
  [attr.button-aria-expanded]='""'
></ds-button>